module.exports = __webpack_public_path__ + "static/media/slot-8.4210ee32.png";